export function flattenMenuPaths(menuTree = []) {
  const result = [];
  const walk = (nodes) => {
    (nodes || []).forEach((node) => {
      if (node && node.pathUrl) {
        result.push(node.pathUrl);
      }
      if (node && node.children && node.children.length) {
        walk(node.children);
      }
    });
  };
  walk(menuTree);
  return Array.from(new Set(result));
}

/** 取第一个可访问的叶子菜单路径，避免落到仅目录路径后被子路由 redirect 到无权限页 */
export function firstAccessibleMenuPath(menuTree = []) {
  const paths = flattenMenuPaths(menuTree);
  if (!paths.length) {
    return "";
  }
  const leaves = paths.filter(
    (path) => !paths.some((other) => other !== path && other.startsWith(`${path}/`))
  );
  return leaves[0] || paths[0];
}

export function hasPerm(userInfo = {}, perm = "") {
  if (!perm) {
    return true;
  }
  const perms = userInfo.perms || [];
  return perms.includes(perm);
}
